import omit from 'lodash/omit';

import type { TransType } from '@/contexts/translations';
import type { I18nContentImage, I18nContentLabel } from '@/graphql/generated';

/**
 * convert key value pair array from contentful
 * into Object
 * @param param0
 * @returns
 */
export const normalizeTranslations = ({
  i18nContentLabel,
  i18nContentImage,
  appContentWithKeyNonProd,
}: {
  i18nContentLabel?: I18nContentLabel[];
  i18nContentImage?: I18nContentImage[];
  appContentWithKeyNonProd?: boolean;
}): TransType => {
  const ret: TransType = {
    label: {},
    image: {},
  };

  i18nContentLabel?.forEach((item) => {
    const key = item.key;
    ret.label[key] = appContentWithKeyNonProd
      ? `[${key}] ${item.label}`
      : item.label;
  });

  i18nContentImage?.forEach((item) => {
    const key = item.key;
    ret.image[key] = omit(item.image, ['__typename']);
  });

  return ret;
};

/**
 * replace placeholder key with {{}} schema inside given
 * string.
 * @param str original string.
 * @param args key value pair where key matches {{key}} in given string.
 * @returns replaced string
 */
export function replaceAll(str = '', args: Record<string, string | number>) {
  const regex = new RegExp(
    Object.keys(args)
      .map((a) => `{{${a}}}`)
      .join('|'),
    'gi',
  );

  return str.replace(regex, (matched) => {
    return (args[matched?.replace(/\{\{|\}\}/gi, '')] ?? '').toString();
  });
}
